import React from 'react';
import {Props} from './types';
import {highlight} from './utils';


const View: React.FC<Props> = (props: Props) => (
  <div
    className='d-flex flex-column overflow-hidden'
    style={{height: props.state.height, flex: 1}}
  >
    <div className='d-flex align-items-end justify-content-end'>
      <button
        className='btn-plane-yellow'
        type="button"
        onClick={props.handlers.focus}
      >
        Zoom
      </button>
    </div>
    <div className='d-flex flex-column overflow-scroll'>
      {props.state.isLoaging ?
      <p>loading...</p> :
      <div className='d-flex flex-column'>
        {props.store.results.length > 0 ? props.store.results.map((eachResult, key) => {
          const title = eachResult.title || '';
          const body = eachResult.text.split('\n').slice(1).join(' ').slice(0, 200);
          return (
            <section key={key} className='text-gray-800 px-2 py-4'>
              <h3
                onClick={() => props.handlers.handleClickArticle(key)}
                style={{
                  cursor: 'pointer',
                }}
              >
                {highlight(title, 0, () => {}, 'text-purple-500')}
              </h3>
              <p className='text-gray-500'>
                {highlight(body, key, () => {}, 'text-purple-500')}...
              </p>
            </section>
          );
        }) :
        <p className='p-4'>該当文書なし</p>
        }
      </div>
      }
    </div>
  </div>
);


export default View;
